export default __webpack_public_path__ + "media/gs_upgrade_email/banner_img-1a215273.jpg";